import './app.less';
import App from './App.svelte';

window.__SVELTE_SCORE_APP__ = true;

const app = new App({
	target: document.getElementById('scoreapp'),
	props: {
	}
});

export default app;
